import { OptionsButton } from '@starrez/starryui';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import * as PopperJS from 'popper.js';
import React from 'react';
import styled from 'styled-components';

const OptionButtonSize = 40;
const OptionButtonSizeWithBorder = OptionButtonSize + 2;

const OptionsColumnDefBase: ColDef = {
    headerName: '',
    field: 'options-menu',
    filter: false,
    sortable: false,
    resizable: false,
    colId: 'options-menu',
    width: OptionButtonSizeWithBorder,
    minWidth: OptionButtonSizeWithBorder,
    maxWidth: OptionButtonSizeWithBorder,
    cellStyle: {
        padding: 0,
        width: `${OptionButtonSize}px`,
        height: `${OptionButtonSize}px`,
        border: 'none',
    },
};

export interface IOptionColumnCell {
    ariaLabel: string;
    title: string;
    placement?: PopperJS.Placement;
    Component: React.FC<Partial<ICellRendererParams>>;
}

export const OptionsColumn = ({ ariaLabel, title, placement = 'bottom-start', Component, ...props }: IOptionColumnCell) => {
    return (
        <OptionsButtonWrapper>
            <OptionsButton
                AriaLabel={ariaLabel}
                ButtonSize={`${OptionButtonSize}px`}
                IconDirection={'Vertical'}
                IconSize={'24px'}
                Title={title}
                Placement={placement}
                DisableAutoFocus={false}
            >
                <Component {...props} />
            </OptionsButton>
        </OptionsButtonWrapper>
    );
};

export function useOptionsColumn({ ariaLabel, title, placement, Component }: IOptionColumnCell) {
    return {
        ...OptionsColumnDefBase,
        cellRendererFramework: OptionsColumn,
        cellRendererParams: {
            ariaLabel,
            title,
            placement,
            Component,
        },
    };
}

const OptionsButtonWrapper = styled.div`
    display: grid;
    height: 100%;
    justify-content: center;
    align-content: center;
`;
